// Angular
import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
// RxJS
import { combineLatest, Observable, of, Subscription } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { AuthService, currentUser, Logout, User } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { PlantService } from '../../../../../core/plant-configuration/_services/plant.service';

@Component({
	selector: 'kt-user-profile3',
	templateUrl: './user-profile3.component.html',
})
export class UserProfile3Component implements OnInit {
	// Public properties
	user$: Observable<User>;

	@Input() avatar = true;
	@Input() greeting = true;
	@Input() badge: boolean;
	@Input() icon: boolean;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */

	// Listen to scroll event to change logout button style
	scrolledH = 1;
	companyList: any;
	selectedCompany: any = {id: -1, name: 'seleccione una empresa'};
	currentCompany: any = {id: -1, name: 'seleccione una empresa'};
	user: User;
	plantList: any[] = [];
	currentPlant: any = {id: -1, name: "Planta sin definir"};
	@HostListener('window:scroll', ['$event'])
	onWindowScroll($event) {
		const numb = window.scrollY;
		if (numb >= 75){
		this.scrolledH = 0;
		}
		else {
		this.scrolledH = 1;
		}
	}

	constructor(
		private store: Store<AppState>,
		private companyService: CompanyService,
		private plantService: PlantService,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private authService: AuthService
	) {}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	private subscriptions: Subscription[] = [];
	ngOnInit(): void {
		this.user$ = this.store.pipe(select(currentUser));
		this.subscriptions.push(
			of(null).pipe(
				switchMap(()=>combineLatest([
					this.companyService.getAll(),
					this.user$
				]))
			).subscribe(([companyList, user])=>{
				this.user = user;
				// console.log("usuario");console.dir(user);
				this.companyList = companyList;
				// this.selectCompany(user.company_id);
				this.cdr.detectChanges();
				this.currentCompany = this.companyService.getCurrentCompany();
				// this.currentPlant = this.plantList.find(plant=>plant.company_id = this.currentCompany.id);
				// if(this.currentPlant == null) this.currentPlant = {id: -1, name: "Planta sin definir"}
				// this.plantService.setCurrentPlant(this.currentPlant);
				this.selectCompany(this.currentCompany.id);
				this.changeCurrentCompany();
				// if(this.selectedCompany.id != -1 && ((this.user && ![4,5].includes(this.user.group_id)) || this.currentCompany.id==-1)){
				// 	this.changeCurrentCompany();
				// }
			}, (err)=>{
				//console.log("USER PROFILE 3 ERROR : ", err)
			})
		);
	}

	selectCompany(companyId){
		// console.log(`searching company id: ${companyId}`);
		this.selectedCompany = this.companyList.find(company=>company.id==companyId);
	}

	onClickSelectCompany(){
		this.changeCurrentCompany();
		this.router.navigateByUrl('/',{skipLocationChange: true}).then(()=>{
			this.router.navigate(['']);
		});
	}

	changeCurrentCompany(){
		if(this.selectedCompany.id == -1 || (this.user && (![4,5].includes(this.user.group_id) && this.currentCompany.id!=-1))) return;
		this.currentCompany = this.selectedCompany;
		this.companyService.setCurrentCompany(this.currentCompany);
		this.subscriptions.push(of(null).pipe(
			switchMap(()=>this.plantService.getAll())
		).subscribe(plantList=>{
			this.plantList = plantList;
			this.currentPlant = this.plantList.find(plant=>plant.company_id = this.currentCompany.id);
			// console.log("plant found for company "+this.currentCompany.name);console.dir(this.currentPlant);
			// console.log("plant list: ");console.dir(this.plantList);
			if(this.currentPlant == null) this.currentPlant = {id: -1, name: "Planta sin definir"}
			this.plantService.setCurrentPlant(this.currentPlant);
		}));
	}

	/**
	 * Log out
	 */
	logout() {
		this.authService.signOut();
		this.store.dispatch(new Logout());
	}

	toggle(event) {
		event.stopPropagation();
		// logic for accordion
	  }
}
